// Exported mutable ref is just to handle synchronous try..catch.
// When do statements are added to JS, this won't be needed anymore.
let config: Record<string, any> = {};

try {
  config = JSON.parse(
    (document.querySelector('#root') as HTMLElement).dataset.config!,
  );
} catch (error) {
  console.log('Failed to load app config vars');
}

export default config;
